import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatCheckboxModule, MatCheckbox } from '@angular/material/checkbox';

export interface SectionOptionsSettings {
  title: string;
  options: SectionOptionSettings[];
  sectionId: number | string;
  customClass?: string;
  customStyle?: Record<string, string | number>;
  required?: boolean;
  errorMessage?: string;
}

export interface SectionOptionSettings {
  id: string | number;
  checked: boolean;
  disabled?: boolean;
  customClass?: string;
  tooltip?: string;
  value: string;
  onClick?: (params: SectionOptionClickEvent) => void;
}

export interface SectionOptionClickEvent {
  checkbox: MatCheckbox;
  sectionSettings: SectionOptionsSettings;
  item: SectionOptionSettings;
}

@Component({
  selector: 'miq-section-options',
  template: `
    <div class="section-options__wrapper">
      <div class="section-options__title">
        <div>
          {{ sectionSettings.title }}
          <span *ngIf="sectionSettings.required" class="section-options__required-icon"> * </span>
        </div>

        <div *ngIf="!!sectionSettings.errorMessage" class="section-options__error-msg">
          {{ sectionSettings.errorMessage }}
        </div>
      </div>

      <div class="section-options__content">
        <div
          *ngFor="let item of sectionSettings.options"
          [ngStyle]="sectionSettings.customStyle"
          [ngClass]="sectionSettings.customClass"
          [style.width]="columnsByRowCalculation"
          class="section-options__content-item"
        >
          <mat-checkbox
            #checkbox
            [id]="'e2e-section-option__' + item.id"
            [checked]="!!item.checked"
            [disabled]="item.disabled"
            [ngClass]="item.customClass"
            (click)="onCheckboxToggle(checkbox, item)"
          >
            <span [matTooltip]="item.tooltip" matTooltipPosition="below">
              {{ item.value }}
            </span>
          </mat-checkbox>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./section-options.component.scss'],
  imports: [CommonModule, MatCheckboxModule],
})
export class SectionOptionsComponent {
  @Input() sectionSettings: SectionOptionsSettings;
  @Input() set columnsByRow(val: number) {
    this.columnsByRowCalculation = this.claculateOptionWidth(val);
  }

  @Output() selectionChange = new EventEmitter();

  columnsByRowCalculation: string;

  constructor() {
    this.columnsByRowCalculation = this.claculateOptionWidth();
  }

  private claculateOptionWidth(columnsByRow?: number) {
    const numberOfColumnsByRow = columnsByRow ?? 3;
    // The value 4 is coming from the gap configured between columns
    const sumOfGapBetweenColumns = (numberOfColumnsByRow - 1) * 4;
    return `calc((100% - ${sumOfGapBetweenColumns}px ) / ${numberOfColumnsByRow})`;
  }

  onCheckboxToggle(checkbox: MatCheckbox, item: SectionOptionSettings) {
    if (item.disabled) {
      return;
    }
    if (item.onClick) {
      return item.onClick({ checkbox, sectionSettings: this.sectionSettings, item });
    }
    this.selectionChange.emit({ checkbox, sectionSettings: this.sectionSettings, item });
  }
}
